app.controller('UserPerformanceController', ['$scope', '$routeParams', 'WdHttpService',
    'sessionService',
    function($scope, $routeParams, WdHttpService, sessionService) {

        var username = sessionService.get("cognito_username");
        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();

            $scope.isActiveTab = [true, false, false];
            $scope.fundName = $routeParams.fund;
            $scope.adviserUsername = $routeParams.adviser;
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.transactionList = [];
            $scope.performanceData = {};
            $scope.holdingList = [];
            await $scope.refreshPerformance();
        };

        $scope.refreshPerformance = async function() {

            var data = {
                investingMode: $scope.investingMode
            };
            $scope.showPageLoader();
            await WdHttpService._refresh_my_portfolio(data)
                .then(async function(response) {
                    if (response.status == 200) {
                        await $scope.getTransactions();
                        await $scope.getFundDetails();
                    }
                    // $scope.hidePageLoader();
                }).catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup('Failed to update your performance as of now, retry again later.');
                    console.error(error);
                });
        }

        $scope.getFundDetails = async function() {
            var data = {
                q: "fundName:" + $routeParams.fund,
                f: "web_admin:" + $scope.webadminName
            };
            WdHttpService._get_funds(data).then(function(response) {
                if (response.status == 200) {
                    var fundDetail;
                    // $scope.hidePageLoader();
                    // This if condition is coded due to a server side bug to be fixed yet.
                    if (response.data.Items.length > 1) {
                        response.data.Items.forEach(fund => {
                            if (fund.fundName == $routeParams.fund)
                                fundDetail = fund;
                            $scope.benchmark = fundDetail.benchmark;
                        });
                    } else
                        fundDetail = response.data.Items[0];

                    if (fundDetail) {
                        $scope.benchmark = fundDetail.benchmark;
                        $scope.getInvestments();
                    }
                    $scope.$evalAsync();
                }
            }).catch(error => {
                console.log(error);
                $scope.showErrorPopup(error);
                $scope.$evalAsync();
                $scope.hidePageLoader();
            });
        }

        $scope.getInvestments = function() {
            var data = {
                benchmark: $scope.benchmark,
                fund: $scope.fundName,
                adviserUsername: $scope.adviserUsername,
                investingMode: $scope.investingMode
            };
            $scope.showPageLoader();
            WdHttpService._user_investments_data(data)
                .then(function(response) {
                    $scope.adviserName = response.data.adviserName;
                    $scope.displayName = response.data.displayName;
                    $scope.performanceData = {
                        "subscriptionTimestamp": response.data.subscriptionTimestamp,
                        "benchmarkPerformance": response.data.benchmarkPerformance,
                        "pnl": response.data.pnl,
                        "totalInvestment": response.data.totalInvestment,
                        "totalBrokerage": response.data.totalBrokerage,
                        "withdrawals": response.data.withdrawals,
                        "netInvestment": response.data.netInvestment,
                        "portfolioValue": response.data.portfolioValue,
                        "portfolioReturns": response.data.portfolioReturns,
                        "portfolioIRR": response.data.portfolioIRR,
                        "indexIRR": response.data.indexIRR,
                        "irrWithTimestamp": response.data.irrWithTimestamp,
                        "timestamp": response.data.timestamp,
                        "realisedPnL": response.data.realisedPnL,
                        "unrealisedPnL": response.data.unrealisedPnL,
                        "totalDividend": response.data.totalDividend,
                        "SLBIncome": response.data.SLBIncome
                    };
                    angular.forEach(response.data.currentHoldings, function(value, key) {
                        $scope.holdingList.push({
                            "symbol": value.symbol,
                            "quantity": value.quantity,
                            "buyValue": value.buyValue,
                            "currentPrice": value.currentPrice,
                            "currentValue": value.currentValue,
                            "buyPrice": value.buyPrice,
                            "holdingReturn": value.holdingReturn
                        });
                    });
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.hidePageLoader();
                });

        }

        $scope.getTransactions = function() {
            var data = {
                fund: $scope.fundName,
                adviserUsername: $scope.adviserUsername,
                investingMode: $scope.investingMode
            };
            WdHttpService._user_transactions_data(data)
                .then(function(response) {
                    angular.forEach(response.data, function(value, key) {
                        $scope.transactionList.push({
                            "symbol": value.symbol,
                            "exchange": value.exchange,
                            "quantityBought": value.quantityBought,
                            "averageBuyPrice": value.averageBuyPrice,
                            "quantitySold": value.quantitySold,
                            "averageSellPrice": value.averageSellPrice,
                            "realisedProfit": value.realisedProfit,
                            "orderIssueTimestamp": value.orderIssueTimestamp,
                            "orderCloseTimestamp": value.orderCloseTimestamp
                        });
                    });
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                    $scope.$evalAsync();
                    $scope.hidePageLoader();
                });
        }

        $scope.changeTabs = function(tabSwitch) {
            for (let i = 0; i < $scope.isActiveTab.length; i++) {
                if (i == tabSwitch)
                    $scope.isActiveTab[i] = true;
                else
                    $scope.isActiveTab[i] = false;
            }
        }

        $scope.downloadPDF = async function() {
            var data = {
                investingMode: $scope.investingMode,
                benchmark: $scope.benchmark
            }
            $scope.showPageLoader();
            var pdfUrl = await WdHttpService._holdings_export($routeParams.adviser, $routeParams.fund, data)
                .catch(error => {
                    $scope.showErrorPopup(error);
                    return undefined;
                });

            if (pdfUrl) {
                var a = document.createElement('a');
                a.href = pdfUrl;
                a.click();
            }
            $scope.$evalAsync();
            $scope.hidePageLoader();
        }

    }
]);